import {Directive, Input} from '@angular/core';
import {
  AbstractControl,
  NG_VALIDATORS,
  ValidationErrors,
  Validator,
  ValidatorFn,
} from '@angular/forms';

export function maxDateValidator(maxDate: Date): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const date = new Date(control.value);
    const isAfterMaxDate = date > maxDate;
    return isAfterMaxDate ? { maxDate: { value: date, max: maxDate } } : null;
  };
}

@Directive({
  selector: '[appMaxDate]',
  providers: [{provide: NG_VALIDATORS, useExisting: MaxDateDirective, multi: true}],
  standalone: false
})
export class MaxDateDirective implements Validator {
  @Input('appMaxDate') maxDate: Date;

  validate(control: AbstractControl): ValidationErrors | null {
    return this.maxDate ? maxDateValidator(this.maxDate)(control) : null;
  }
}
